import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ConfirmationDialog from "./common-components/ConfirmationDialog";
import { logout } from "./actions/admin-actions";

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

const AppLogout = ({ children }) => {
  const dispatch = useDispatch();

  const [confirmOpen, setConfirmOpen] = useState(false);

  const logoutData = useSelector((state) => state.adminReducer.logoutData);

  let timer;

  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      resetTimer();
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      logoutAction();
    }, 2 * 60 * 60 * 1000);
  };

  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });
  }, []);

  const logoutAction = () => {
    dispatch(logout());
  };

  useEffect(() => {
    if (
      logoutData &&
      logoutData.status &&
      (logoutData.status === 200 || logoutData.status === 400)
    ) {
      localStorage.clear();
      setTimeout(() => (window.location.href = "/logout"), 100);
    }
  }, [logoutData]);

  const okConfirmClick = (val) => {
    if (val) {
      setConfirmOpen(false);
      localStorage.clear();
      window.location.pathname = "/logout";
    }
  };

  const cancelConfirmClick = (val) => {
    if (val) {
      setConfirmOpen(false);
      resetTimer();
    }
  };

  return (
    <>
      {children}
      {confirmOpen && (
        <ConfirmationDialog
          cancelClick={cancelConfirmClick}
          okClick={okConfirmClick}
          confirmText="Do you want to logout from the application?"
          closeDialog={() => setConfirmOpen(false)}
          title="Confirm Logout"
          buttonText="Logout"
        />
      )}
    </>
  );
};

export default AppLogout;
